import { defineComponent as _defineComponent } from 'vue'
import { useUserspace } from '@/store/userspace';
import { auth } from '@/util/firebase';
import { InviteLinks } from '@busy-human/opt-library'
import { useRouter } from 'vue-router';

type Props = {
    invite: InviteLinks.Model
}
type Emits = {
    (e: 'update:invite', invite: InviteLinks.Model): void
    (e: 'progress'): void
    (e: 'previous'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'invite-type',
  props: {
    invite: null
  },
  emits: ["update:invite", "progress", "previous"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'update:invite', invite: InviteLinks.Model): void
    (e: 'progress'): void
    (e: 'previous'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    invite: InviteLinks.Model
}



const router = useRouter();

const goTo = (path: string, hash?: string) =>{
    let route:any = {path:path}
    if(hash)
        route['hash'] = hash
    router.push(route)
}



const userspace = useUserspace();

const setType = (type: 'payer' | 'collector') => {
    if(type === 'payer') {
        const tmp = InviteLinks.DefaultPayer()
        tmp.payer = userspace.uid;
        emit('update:invite', tmp)
    } else if(type === 'collector') {
        const tmp = InviteLinks.DefaultCollector()
        tmp.collector = userspace.uid;
        emit('update:invite', tmp);
    }
    emit('progress');
}


const __returned__ = { props, router, goTo, emit, userspace, setType, useUserspace, auth, InviteLinks, useRouter }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})